<!-- Invalid handler for event “click“: got undefined  @click="formData.xxx" 是 formData.xxx 报的错-->
<!-- 询价单详情 -->
<template>
  <div v-loading="detailLoading" class="enquiry-detail-com">
    <e-process :process-data="processData" :is-active="activeIndex"></e-process>
    <div class="line"></div>
    <!--程序报错，暂时注释掉-->
    <el-form ref="formDom" :model="formData" class="form-content" size="small">
      <el-row>
        <el-col :span="12">
          <el-form-item label-width="120px" label="询价单名称：" prop="enquiryName">
            <span>{{ formData.enquiryName }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 询价商品清单 -->
      <div class="commodity-list">
        <div class="title">询价商品清单</div>
        <div class="commodity-content">
          <!-- table -->
          <div class="table-content">
            <el-table
              :data="enquiryDetailList"
              border
              max-height="455"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
              size="small"
            >
              <el-table-column label="序号" width="60px" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="商品名称" min-width="260" align="center" prop="productName"></el-table-column>
              <el-table-column label="需求数量" min-width="90" align="center" prop="requiredQuantity"></el-table-column>
              <el-table-column label="计量单位" min-width="90" align="center" prop="unitName"></el-table-column>
              <el-table-column label="规格型号" min-width="200" align="center" prop="specifications"></el-table-column>
              <el-table-column label="品牌" min-width="120" align="center" prop="brandName"></el-table-column>
              <el-table-column
                label="商品描述"
                min-width="160"
                align="center"
                prop="productDescription"
              ></el-table-column>
              <el-table-column label="商品目录" min-width="180" align="center" prop="categoryName"></el-table-column>
              <el-table-column label="操作" width="120px" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      scope.row.enquiryDetailAttachmentList.length &&
                      scope.row.enquiryDetailAttachmentList[0].attachmentUrl
                    "
                    size="small"
                    type="text"
                    @click="uploadDesc(scope.$index, scope.row)"
                  >
                    查看需求描述
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!-- 询价类型 -->
      <div class="commodity-list" style="margin-top: 10px">
        <div class="title">询价类型</div>
        <div class="commodity-content">
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="100px" label="询价类型：" prop="enquiryType" style="margin: 0">
                <el-radio-group v-model="formData.enquiryType" disabled>
                  <el-radio :label="1">公开询价</el-radio>
                  <el-radio :label="0">定向询价</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 供应商信息 -->
      <div v-if="formData.enquiryType === 0 && isChoice" class="commodity-list" style="margin-top: 10px">
        <div class="title">供应商信息</div>
        <div class="commodity-content">
          <div class="table-content">
            <el-table
              :data="enquirySupplierList"
              style="width: 100%"
              border
              size="small"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column prop="date" label="序号" width="60px">
                <template #default="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="supplierCompany" label="供应商名称" min-width="180"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 基本信息 -->
      <div class="commodity-list" style="margin-top: 10px">
        <div class="title">基本信息</div>
        <div class="enquiry-form">
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="运费：" prop="includeFreight">
                <el-radio-group v-model="formData.includeFreight" disabled>
                  <el-radio :label="0">包含在商品中</el-radio>
                  <el-radio :label="1">单独明细提报</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="结算方式：" prop="releaseTime">
                <span>{{ formData.isDoC != undefined ? (formData.isDoC === 1 ? '货到付款' : '款到发货') : '' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="配送方式：" prop="quotationDeadline">
                <span>{{ formatShipmentType(formData.shipmentType) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label-width="142px" label="报价限额：" prop="quotationLimit">
              {{ formData.quotationLimit }}
              <span v-if="formData.quotationLimit">元(含税)</span>
            </el-form-item>
          </el-row>
          <el-row>
            <!-- <div v-if="enquiryStatus <= 1 || enquiryStatus === 11">
              <el-form-item label-width="142px" label="询价周期选择：">
                <el-radio-group
                  v-model="formData.inquiryCycleType"
                  :disabled="isChoice"
                >
                  <el-radio :label="0">按照日期</el-radio>
                  <el-radio :label="1">按照天数</el-radio>
                </el-radio-group>
              </el-form-item>
            </div> -->
            <div
              v-if="formData.inquiryCycleType === 0 || (formData.enquiryStatus > 1 && formData.enquiryStatus !== 11)"
            >
              <el-col :span="12">
                <el-form-item label-width="142px" label="报价开始时间：" prop="releaseTime">
                  <span>{{ formData.releaseTime }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="142px" label="报价截止时间：" prop="quotationDeadline">
                  <span>{{ formData.quotationDeadline }}</span>
                </el-form-item>
              </el-col>
            </div>
            <div v-else>
              <!-- style="margin-left: 116px"  -->
              <el-col :span="8">
                <el-form-item label-width="142px" label="询价周期：" prop="days">
                  <span>{{ `${formData.days}天` }}</span>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8" class="date-icon">
                <el-tooltip
                  class="right-icon"
                  style="left: -40px; top: 8px"
                  effect="dark"
                  placement="top"
                >
                  <div slot="content">
                    <p>询比价开始时间为平台审核通过的时间</p>
                  </div>
                  <div class="icon">?</div>
                </el-tooltip>
              </el-col> -->
            </div>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="期望到货日期：" prop="arrivalTime">
                <span>{{ formData.arrivalTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="邮箱：" prop="email">
                <span>{{ formData.email }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="联系人：" prop="realName">
                <span>{{ formData.realName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="联系方式：" prop="mobile">
                <span>{{ formData.mobile }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="收货地址：">
                <span>
                  {{ formData.address }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="备注：" aria-placeholder="请输入备注信息">
                {{ formData.enquiryRemark }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="附件：" type="textarea">
                <el-tooltip
                  v-for="item of enquiryAttachmentUrlShow"
                  :key="item.fileUrl"
                  effect="dark"
                  :content="item.fileName"
                  placement="bottom"
                  :disabled="checkTextOverflow(item.fileName)"
                >
                  <span class="file-name" @click="downloadFile(item)">
                    {{ item.fileName }}
                  </span>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="是否公示：" prop="whetherPublic">
                <el-radio-group v-model="formData.whetherPublic" disabled>
                  <el-radio :label="0">是</el-radio>
                  <el-radio :label="1">否</el-radio>
                  <!-- <el-tooltip class="right-icon" style="left: 124px" effect="dark" placement="top">
                    <div slot="content">
                      <p>是否把询价结果公示在平台上</p>
                    </div>
                    <div class="icon">?</div>
                  </el-tooltip> -->
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>

      <div v-if="!isHiddenAgreement" class="commodity-list" style="margin-top: 10px">
        <div class="title">询比价服务协议</div>
        <div class="commodity-content">
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="100px" label="服务协议：" prop="enquiryType" style="margin: 0">
                <eui-btn type="link" @click="quotationNoticeVisible = true">《易派客平台询比价服务协议》</eui-btn>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <quotation-notice-dialog
      v-if="quotationNoticeVisible"
      protocol-type="purchaser"
      :quotation-notice-visible="quotationNoticeVisible"
      is-view
      :rate-num="rateNum"
      @closeDialog="handleCloseDialog"
    />
  </div>
</template>
<script>
import EProcess from '@/modules/projectA/components/common/e-process.vue';
import { dealAttachmentName } from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/enquiry';
import quotationNotice from '@/modules/projectA/components/enquiry/quotationNotice';
import hideCompanyMixin from '@/modules/projectA/components/enquiry/hideCompanyMixin';

export default {
  components: {
    EProcess,
  },
  mixins: [quotationNotice, hideCompanyMixin],
  props: {
    isChoice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const enquiryTypeObj = {
      0: '定向询价',
      1: '公开询价',
    };
    return {
      activeIndex: 1,
      detailLoading: false,
      processData: [
        {
          itemName: '发布询价需求',
          title: '发布询价需求',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '供应企业报价',
          title: '供应企业报价',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '选商定价',
          title: '选商定价',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '结果公示',
          title: '结果公示',
          tip: '',
          description: '',
          icon: '',
        },
      ],
      supplierTableList: [],
      enquiryTypeObj,
      categoryInfo: {},
      // 头信息
      productDetail: {},
      limit: 1,
      fileSize: 30,
      // 上传需求描述的index
      clickTableIndex: 0,
      // 列表验证+列表数据
      formData: {
        includeFreight: 0,
        enquiryType: 1,
        address: '',
        enquiryName: '',
        realName: '',
        mobile: '',
        quotationDeadline: '',
        releaseTimeStart: '',
        arrivalTime: '',
        isDoC: '',
        shipmentType: '',
        whetherPublic: -1,
        quotationLimit: '',
      },
      enquiryDetailList: [],
      tableData: [],
      enquiryTypeFlag: false,
      // 定向询价供应商列表
      enquirySupplierList: [],
      addressVisible: false,
      enquiryAttachmentUrlShow: [],
      enquiryStatus: 0,
      /* endTime: "",
      beginTime: "",
      pickerBeginDate: {
        disabledDate: time => {
          let endTime = this.endTime;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      // /限制不能选之前的时间
      pickerEndDate: {
        disabledDate: time => {
          let beginTime = this.beginTime;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime();
          }
        }
      } */
    };
  },
  mounted() {
    let { enquiryStatus } = this.$route.query;
    const { enquiryId } = this.$route.query;
    enquiryStatus = Number(enquiryStatus);
    this.enquiryStatus = enquiryStatus;
    /*
      // 生成订单
      0: '草稿', // 已保存
      1: '待平台审核', // 有
      2: '待报价', // 有
      3: '待揭示', // 有
      4: '已揭示', // 有
      5: '询价完成', // 有
      //6: "生成订单", // 已下单
      7: '生成订单', // 有
      8: '询价作废', // 没有
      9: '审核拒绝', // 有
      10: '询价过期', // 没有
      11: '待审批', // 新
      12: '选商定价待审批',
      13: '审批拒绝',
      14: '中选通知待确认',
    */
    switch (enquiryStatus) {
      case 0:
      case 1:
      case 9:
        this.activeIndex = 1;
        break;
      case 2:
      case 3:
      case 4:
        this.activeIndex = 2;
        break;
      case 12:
      case 14:
        this.activeIndex = 3;
        break;
      case 5:
      case 6:
      case 7:
        this.activeIndex = 4;
        break;
      case 8:
      case 10:
        this.activeIndex = -1;
        break;
      default:
        this.activeIndex = -1;
        break;
    }
    this.getDetailInfo({ enquiryId: Number(enquiryId) });
  },
  methods: {
    dealAttachmentName,
    handleCloseDialog() {
      this.quotationNoticeVisible = false;
    },
    checkTextOverflow(str) {
      let count = 0; // 初始化字节数递加变量并获取字符串参数的字符个数
      if (str) {
        // 如果存在字符串，则执行
        for (let i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) > 255) {
            // 字符编码大于255，说明是双字节字符(即是中文)
            count += 2;
          } else {
            count++;
          }
        }
      }
      return count <= 20;
    },
    downloadFile(fileObj) {
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(fileObj.fileUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileObj.fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    goBack() {
      console.log(11111);
      this.$router.push({
        path: '/enquiryManage/enquiry',
      });
    },
    uploadDesc(index, row) {
      const fileArr = row.enquiryDetailAttachmentList;
      const file = fileArr[0];
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(file.attachmentUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = file.attachmentName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    // 采购商-查询询价单详情
    async getDetailInfo(params) {
      this.detailLoading = true;
      await Api.queryEnquiryDetailByEnquiryId(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.getRateNum(data);
          this.formData = { ...this.formData, ...data };
          // 展示转换
          // 展示转换
          if (data.enquiryAttachmentList?.length) {
            const enquiryAttachmentUrlShow = data.enquiryAttachmentList;
            this.enquiryAttachmentUrlShow = enquiryAttachmentUrlShow.map((item) => ({
              fileUrl: item.attachmentUrl,
              fileName: item.attachmentName,
            }));
          }
          if (data.enquirySupplierList && data.enquirySupplierList.length !== 0) {
            this.enquirySupplierList = [...data.enquirySupplierList];
          }
          this.enquiryDetailList = [...data.enquiryDetailList];

          // 封装发起审批人数据
          const firstData = {
            step: '发起审批',
            icon: require('@/assets/img/approval/fqsp.png'),
            auditStatus: 1,
            nodeMember: {
              auditMemberPhone: this.formData.mobile,
              auditMemberName: this.formData.createMemberName,
              approveTime: this.formData.createTime,
            },
          };

          // 选商定价发起人数据
          const setPriceFirstData = {
            step: '发起审批',
            icon: require('@/assets/img/approval/fqsp.png'),
            auditStatus: 1,
            nodeMember: {
              auditMemberPhone: this.formData.selectivePriceAuditMobile,
              auditMemberName: this.formData.selectivePriceAuditMemberName,
              approveTime: this.formData.selectPriceAuditTime,
            },
          };

          // 封装最后节点数据
          const lastData = {
            enquiryStatus: this.formData.enquiryStatus,
            refuseReason: this.formData.refuseReason,
          };

          this.$emit(
            'queryAuditBusinessFlowLogList',
            firstData,
            lastData,
            setPriceFirstData,
            this.formData.purchaseCompanyId
          );
        }
      });
    },
    // 开课时期
    startClassChange(courseDay) {
      this.formData.quotationDeadline = courseDay || '';

      if (courseDay) {
        courseDay && this.endClassChange(courseDay + 13 * 24 * 3600 * 1000);
      }
    },
    // 节课时期
    endClassChange(endCourseDay) {
      this.formData.arrivalTime = endCourseDay || '';
    },
    formatShipmentType(type) {
      let str = '';
      if (type === 1) {
        str = '卖家自行配送';
      } else if (type === 3) {
        str = '第三方物流';
      }
      return str;
    },
  },
};
</script>
<style lang="scss" scoped>
.enquiry-detail-com {
  width: 100%;
  background: #fff;
  .line {
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
  }
  .search-form {
    display: flex;
    .el-input {
      width: 200px;
    }
  }
  .form-content {
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-date-editor.el-input {
      width: 100%;
      .el-input__inner {
        border-radius: 0;
      }
    }
    ::v-deep .el-input {
      .el-input__inner {
        border-radius: 0;
      }
    }
  }

  .commodity-list {
    border: 1px solid #f5f5f5;
    &:last-child {
      margin-top: 10px;
    }

    .title {
      height: 40px;
      line-height: 40px;
      background: #f5f5f5;
      padding-left: 20px;
    }
    .commodity-content {
      padding: 10px;
      .set-type {
        line-height: 52px;
        i {
          font-size: 20px;
          cursor: pointer;
          &:hover {
            color: #2587ff;
          }
        }
      }
      .handle-btn {
        margin: 10px 0;
        .el-button {
          border-radius: 0;
        }
      }
      .table-content {
        .edit-input {
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
      }
      .table-handle-btn {
        margin-top: 10px;
        line-height: 38px;
        text-align: center;
        border: 1px dotted #d9d9d9;
        span {
          cursor: pointer;
        }
      }
    }
    .enquiry-form {
      margin-top: 20px;
      ::v-deep .el-select {
        width: 100%;
      }
      .file-name {
        margin-right: 10px;
        color: #0064c8;
        cursor: pointer;
        display: inline-block;
        width: 150px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex-shrink: 0;
        flex-grow: 0;
      }
      ::v-deep .el-date-editor.el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-textarea {
        width: 80%;
        .el-textarea__inner {
          border-radius: 0;
        }
      }

      ::v-deep .el-upload {
        display: block;
      }

      .address-btn {
        color: #0064c8;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .handle-button {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .back-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }
    .right-btn {
      display: flex;
    }
    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-right: 30px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
  .pagination {
    margin-top: 18px;
  }
  .warning-content {
    display: flex;
    align-items: center;
    line-height: 56px;
    background: #fffce8;
    padding-left: 10px;
    margin-top: 10px;
    &::before {
      content: '*';
      color: #f0250f;
    }
  }
}
</style>
